const openVampayWebsite = () => {
    window.open("https://vampay.in/", "_blank");
  };
  
  const reportPaymentPage = () => {
    window.open("https://ticketsupport.vampay.in/", "_blank");
  };

  const goToCallback = (callback:string) => {
    window.open(callback);
  };
  
  const goToCallbackLocation = (callback:string) => {
    window.location.href = callback;
  };
  
  export { openVampayWebsite, reportPaymentPage ,goToCallback,goToCallbackLocation};
  